import { Flex, Heading, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function AssigneeHeader({ assignee, period, year, customComponent, customRightAlignedComponent }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "assigneeHeader",
  });
  const { name, avatarUrl } = assignee;

  const displayType = useBreakpointValue({
    base: "block",
    xl: "flex"
  });

  return (
    <Flex
      alignItems="center"
      marginBlockEnd="4"
      paddingBlockEnd="4"
      borderBlockEndWidth="thin"
      justifyContent="space-between"
      display={displayType}
    >
      <Flex alignItems="center" display={displayType}>
        <Flex alignItems="center">
          <Text fontSize="sm" opacity="0.75">
            {t("assignee")}:
          </Text>
          <Image
            marginInline="3"
            borderRadius="full"
            boxSize="8"
            src={avatarUrl}
            //   Add some local fallback
            fallbackSrc="https://via.placeholder.com/20"
          />
          <Heading size="xs">{name}</Heading>
        </Flex>
        {customComponent}
      </Flex>
      {
        <Flex gap={4}>
          {customRightAlignedComponent}
          {(period || year) &&
            <Flex alignItems="center">
              <Text fontSize="sm" opacity="0.75">
                {typeof period !== "undefined" ? t("period") : t("year")}:
              </Text>
              <Heading size="xs" marginStart="3">
                {typeof period !== "undefined" ? `${period?.year} ${period?.quarter}` : year}
              </Heading>
            </Flex>
          }
        </Flex>
      }
    </Flex>
  );
}

export default AssigneeHeader;